import React from 'react';
import DocumentNodeForm from 'routes/surface/components/node-modal-form/components/document-node-modal/components/document-node-form';
import { useTranslation } from 'i18n';
import { useParams } from 'react-router';
import useSaveSurfaceDocumentNode from 'routes/surface/components/node-modal-form/hooks/use-save-surface-document-node';
import { toast } from 'services/toast';
import { ModalContext } from 'hoc/with-modal';
import { NodeModalInput } from 'types';
import { SurfaceDocumentNode } from 'graphql/types';

export interface RisDocumentNodeFormProps {
  modal: ModalContext;
  backToResults: Function;
  initialValues: NodeModalInput<SurfaceDocumentNode>;
}

function RisDocumentNodeForm({ modal, ...props }: RisDocumentNodeFormProps) {
  const { t } = useTranslation();
  const { id } = useParams();

  const saveSurfaceRisDocumentNode = useSaveSurfaceDocumentNode(id as string);

  function saveRisDocumentNode(input) {
    return saveSurfaceRisDocumentNode({ variables: { input } }).then(
      (response) => {
        if (response.isSuccess) {
          toast.success(t('Successfully created RIS node'));
        } else {
          toast.error(response.getErrorMessage());
        }

        return response;
      },
    );
  }

  return (
    <DocumentNodeForm
      closeForm={modal.hide}
      onSubmit={saveRisDocumentNode}
      initialValues={props.initialValues}
      backButton={(BackButton) => (
        <BackButton onClick={props.backToResults}>
          {t('Back to legal search')}
        </BackButton>
      )}
    />
  );
}

export default RisDocumentNodeForm;
